


// import { AUTH_START, AUTH_SUCCESS, AUTH_FAILURE, LOAD_USER_DATA_SUCCESS, LOAD_USER_DATA_FAILURE } from "../actions/authActions";

// const initialState = {
//   loading: false,
//   data: null,
//   error: null,
//   userData: null,  // Store user data here
// };

// const authReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case AUTH_START:
//       return { ...state, loading: true, error: null };
      
//     case LOAD_USER_DATA_SUCCESS:
//       return {
//         ...state,
//         userData: action.payload,
//         loading: false,
//         error: null,
//       };
//       case "SET_USER_DATA":
//         return {
//             ...state,
//             userData: action.payload,
//         };

//     case LOAD_USER_DATA_FAILURE:
//       return {
//         ...state,
//         userData: null,
//         loading: false,
//         error: action.payload,
//       };

//     case AUTH_SUCCESS:
//       return { 
//         ...state, 
//         loading: false, 
//         data: action.payload.phoneNumber, 
//         error: null 
//       };
      
//     case AUTH_FAILURE:
//       return { ...state, loading: false, error: action.payload };
    
//     default:
//       return state;
//   }
// };

// export default authReducer;


import { 
  AUTH_START, 
  AUTH_SUCCESS, 
  AUTH_FAILURE, 
  LOAD_USER_DATA_SUCCESS, 
  LOAD_USER_DATA_FAILURE,
  RESTORE_SESSION 
} from "../actions/authActions";
const initialState = {
  loading: false,
  data: null,
  error: null,
  userData: null,
  isAuthenticated: false, // Add this field
  phoneNumber: null // Add this field
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, loading: true, error: null };
      
    case RESTORE_SESSION:
      return {
        ...state,
        isAuthenticated: true,
        phoneNumber: action.payload.phoneNumber,
        userData: action.payload.userData,
        data: action.payload.phoneNumber,
        loading: false,
        error: null
      };
      
    case LOAD_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        loading: false,
        error: null,
      };
      
    case "SET_USER_DATA":
      return {
          ...state,
          userData: action.payload,
      };
    case LOAD_USER_DATA_FAILURE:
      return {
        ...state,
        userData: null,
        loading: false,
        error: action.payload,
      };
    case AUTH_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        data: action.payload.phoneNumber, 
        error: null,
        isAuthenticated: true,
        phoneNumber: action.payload.phoneNumber
      };
      
    case AUTH_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.payload,
        isAuthenticated: false 
      };
    
    case "LOGOUT":
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};
export default authReducer;